<template>
  <el-row>
    <el-col :xs='24' :sm='8' :md='6' :lg='5' :xl='4' v-loading="loadingAssignedApplications">
      <applications-lane :assignedApplications="assignedApplications" :assignedApps="assignedApps"></applications-lane>
    </el-col>
    <transition name="el-fade-in-linear">
      <el-col :xs='24' :sm='16' :md='18' :lg='18' :xl='16' v-loading="loadingWorkingApplication">
        <div class="grid-content bg-purple">
          <el-card class="box-card bg-purple" v-if="showWorkingApplication">
            <div class="text item">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="Τίτλος Σπουδών" name="first">
                  <titles :application="workingApplication"></titles>
                </el-tab-pane>
                <el-tab-pane label="Συνυποβολή Τίτλου" name="second"
                  v-if='workingApplication.degreeType === "bachelor" && workingApplication.consideration === true'>
                  <title-consideration :application="workingApplication"></title-consideration>
                </el-tab-pane>
               <el-tab-pane label="Επισυναπτόμενα" name="third">
                  <attached-documents
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :appId="workingApplication.id"
                    :role="role"
                    :generalCommentProp="generalCommentInDocs"
                    :generalCommentWorking="generalCommentWorking"
                    :neededDocuments="workingApplication.neededDocuments"
                    @changedAttachedDocs='changedAttachedDocsEvent'
                    @changedGeneralComment="changedGeneralCommentEvent">
                  </attached-documents>
                </el-tab-pane>
                <el-tab-pane label="Ιστορικό" name="fourth" :lazy=true>
                  <history-line :applicationHistory="history"></history-line>
                </el-tab-pane>
                <el-tab-pane label="Αποτέλεσμα Επεξεργασίας" name="fifth">
                  <academic-consultant-judgment :application='workingApplication'></academic-consultant-judgment>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <application-search v-show="searchVisible"></application-search>
      </el-col>
    </transition>
  </el-row>
</template>
<script>
import { mapState } from 'vuex'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import AcademicConsultantJudgment from './roleSpecific/AcademicConsultantJudgment'
import ApplicationsLane from './common/ApplicationsLane'
import HistoryLine from './common/HistoryLine'
import ApplicationSearch from '@/components/common/ApplicationSearch'

export default {
  name: 'AcademicConsultant',
  components: {
    Titles,
    TitleConsideration,
    AttachedDocuments,
    AcademicConsultantJudgment,
    HistoryLine,
    ApplicationsLane,
    ApplicationSearch
  },
  data () {
    return {
      isCollapse: true,
      role: 'academicconsultant',
      pendingComment: '',
      activeName: 'fifth',
      notificationsDialogVisible: false,
      editable: true,
      isDragging: false,
      delayedDragging: false,
      //   assignedApps: {consultantw_proponent: [{ id: '1', surname: '', createdAt: '', degreeType: '' }],
      //     consultantw_President: [{ id: '2', surname: '', createdAt: '', degreeType: '' }]}
      // }
      assignedApps: {consultantw_President: [{ id: '1', surname: '', createdAt: '', degreeType: '' }]}
    }
  },
  methods: {
    changedGeneralCommentEvent (comment) {
      this.generalComment = comment
    },
    handleOpen (key, keyPath) {
    },
    handleClose (key, keyPath) {
    },
    toggleApplication (element) {
      this.$store.dispatch('LOAD_WORKING_APPLICATION', {appId: element.id})
      // this.showApplication = true
    },
    changedAttachedDocsEvent (docs) {
      let docComments = ''
      docs.forEach(doc => {
        if (doc.precheckerComment) {
          // Todo: this comment must be in English according to language
          docComments +=
            `<div><b>Τύπος</b>: ${doc.type}, <b>Κατάσταση</b>: ${doc.precheckerChecked ? 'Αποδεκτό' : 'Με εκκρεμότητα'}, <b>Σχόλιο</b>: ${doc.precheckerComment}</div>`
        }
      })
      this.judgementDocs = docComments
    },
    handleClick (tab, event) {
    }
  },
  computed: {
    generalCommentWorking () {
      let history = this.workingApplication.applicationHistory
      return history[history.length - 1].judgment !== null &&
        history[history.length - 1].judgment.pendingReason !== null
        ? history[history.length - 1].judgment.pendingReason
        : ''
    },
    generalCommentInDocs () {
      let comments = []
      let history = this.workingApplication.applicationHistory.slice(0)
      comments = history[history.length - 1].judgement !== null &&
        history[history.length - 1].judgement !== undefined &&
        history[history.length - 1].judgement.pendingReason !== null
        ? history
          .filter(step => step.applicationStatus === 'PREPROCESS_TEMPORARY')
        : []
      return comments
    },
    attachedDocumentsTable () {
      return this.workingApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    ...mapState([
      'searchVisible',
      'history',
      'assignedApplications',
      'workingApplication',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication'
    ])
  },
  watch: {
    workingApplication: function (newData, oldData) {
    },
    assignedApplications: function (newData, oldData) {
      this.listAssignedApplications = this.assignedApplications
      // this.listAssignedApplications = this.assignedApplications.map(
      //   application => { return { key: application.id, label: `${application.degreeType}, ${application.surname}, ${application.createdAt.substring(0, 10)}`, disabled: false } })
      // this.myApplications = []
      // this.assignedApplications.forEach(app => {
      //   this.myApplications.push(app.id)
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.commentText {
  width: 320px;
}
.el-card__body {
  padding: 2px;
}
.el-input--small .el-input__inner {
  width: 150px
}
.el-card {
  margin: 5px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.list-group {
  min-height: 20px;
  overflow: hidden;
}

.list-group-item {
  cursor: move;
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}

.list-group-item i{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AcademicConsultant.vue